export default __webpack_public_path__ + "static/media/saint-pierre-sur-dives12.1a6cbc43.jpg";